import React, { useState } from 'react';
import PropTypes from 'prop-types';
import AccordionGroup from '@cx/ui/AccordionGroup';

export const InventoryTypeFilterComponent = props => {
  const [types, setTypes] = useState([]);
  const filter = props.filter;

  const handleCheckboxClick = ({ target }) => {
    if (target.id === 'ckNew') updateTypes(target.checked, 'new');
    if (target.id === 'ckUsed') updateTypes(target.checked, 'used');
    props.handleFilterUpdate('inventoryType', types);
  };

  const updateTypes = (checked, value) => {
    let i = -1;
    if (checked) {
      types.push(value);
    } else {
      i = types.indexOf(value);
      if (i !== -1) types.splice(i, 1);
    }
    setTypes(types);
  };

  return (
    <section className="vlp-filter">
      <AccordionGroup.Container htmlId="inventoryType" independent>
        <AccordionGroup.Item header="Inventory Type" eventKey="1" htmlId="inventoryTypeItem">
          <div className="form-check">
            <input className="form-check-input" type="checkbox" dd="" id="ckNew" onClick={handleCheckboxClick} />
            <label className="form-check-label" htmlFor="ckNew">
              New <span className="badge badge-secondary">{filter.newCount}</span>
            </label>
          </div>

          <div className="form-check">
            <input className="form-check-input" type="checkbox" dd="" id="ckUsed" onClick={handleCheckboxClick} />
            <label className="form-check-label" htmlFor="chUsed">
              Used <span className="badge badge-secondary">{filter.usedCount}</span>
            </label>
          </div>
        </AccordionGroup.Item>
      </AccordionGroup.Container>
    </section>
  );
};

InventoryTypeFilterComponent.propTypes = {
  filter: PropTypes.object,
  handleFilterUpdate: PropTypes.func
};



// WEBPACK FOOTER //
// ./src/components/vehicles/filters/filter/inventoryType.component.js